module.exports = __webpack_public_path__ + "templates-59e97cd7/template-2-79256e2107755cfe33c67c6f14e37013.jpg";